module.exports = __webpack_public_path__ + "img/no_meta_icon.6d7faa63.svg";